/**
 * エラー監視（Sentry）に送る前に個人情報を消す（ADR-0012）。
 * - 文字列：ログイン不要URL・確認URLのトークン、電話番号、メールアドレスを伏せる
 * - イベント：リクエストの本文・クッキー・ヘッダー・ユーザー情報・IP を消し、URL とメッセージを伏せる
 */
const RULES: [RegExp, string][] = [
  [/\/d\/[A-Za-z0-9_-]{16,}/g, "/d/[token]"],
  [/([?&](?:t|token|id_token|code|key)=)[^&\s"']+/g, "$1[redacted]"],
  [/\b[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}\b/g, "[email]"],
  [/\+81\d{9,10}\b/g, "[phone]"],
  [/\b0\d{1,4}-?\d{1,4}-?\d{3,4}\b/g, "[phone]"],
  [/\b[A-Za-z0-9_-]{40,}\b/g, "[secret]"],
];

export function scrubText(s: string): string {
  return RULES.reduce((acc, [re, rep]) => acc.replace(re, rep), s);
}

type Frameless = { value?: string; type?: string };
export type ScrubbableEvent = {
  message?: string;
  request?: { url?: string; data?: unknown; cookies?: unknown; headers?: unknown; query_string?: unknown; env?: unknown };
  user?: unknown;
  extra?: unknown;
  contexts?: Record<string, unknown>;
  exception?: { values?: Frameless[] };
  breadcrumbs?: { message?: string; data?: unknown }[];
  server_name?: string;
};

export function scrubEvent<T extends ScrubbableEvent>(e: T): T {
  const out = { ...e };
  if (out.message) out.message = scrubText(out.message);
  if (out.request) out.request = { url: out.request.url ? scrubText(out.request.url) : undefined };
  delete out.user;
  delete out.extra;
  if (out.contexts) {
    const { os, runtime, browser, device } = out.contexts as Record<string, unknown>;
    out.contexts = { os, runtime, browser, device };
  }
  if (out.exception?.values) out.exception = { values: out.exception.values.map((v) => ({ ...v, value: v.value ? scrubText(v.value) : v.value })) };
  if (out.breadcrumbs) out.breadcrumbs = out.breadcrumbs.map((b) => ({ ...b, message: b.message ? scrubText(b.message) : b.message, data: undefined }));
  return out;
}
